import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/device_update/targetInstallations/"

export class GetPackageTargetInstallationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor(packageId: number) {
        super();
        this.endPoint += packageId;
    }

    public async execute(): Promise<string[]> {
        var res = await this.executeCommand();
        return res.data.Payload.TargetInstallations;
    }

}
